import React, { useEffect, useState } from 'react'
import '../styles/program.scss'



export default function AllOrgs({ appHeightChanged, allOrganizers }) {
 
   
    useEffect(() => {
        appHeightChanged()

    })

    function toFindDuplicates() {
        let arr = []
       
        allOrganizers && allOrganizers.filter((i) => arr.push(i.region))
        const uniqueElements = new Set(arr);
       
        arr.filter((item) => {
            if (uniqueElements.has(item)) {
            
            } else {
                return item;
            }
        });

        return [...new Set(uniqueElements)];
    }

    function BioPerRegion(name) {
      
        let arr = []
        allOrganizers.map((orgs) => {
            if (orgs.region === name) {
                
                arr.push(orgs)
            }
            return arr
        })
        return arr
    }

    const duplicateElements = toFindDuplicates()

    let orgs = []
    for (let i = 0; i < duplicateElements.length; i++) {
        orgs.push({
            region: duplicateElements[i],
            bios: BioPerRegion(duplicateElements[i])
        })
    }
   
   
    return (
         <>
        {
            allOrganizers?
            <div className='biograferContainer'>
              <p className='bio_title' >Vælg biograf</p>
                <p className='bio_count'>I alt: {allOrganizers && allOrganizers.length} biografer bruger billetsystem fra ebillet</p>



                        <section className='biografer'>
                            <div style={{ color: 'lightgrey', fontSize: '14px' }}>
                                {duplicateElements.sort((a, b) => a > b ? 1 : -1).map((i, index) => {
                                    if (i === 'Storkøbenhavn')
                                        return <div key={index}>
                                            <p className='region_name' >{i}</p>
                                            {orgs.sort((a, b) => a.name > b.name ? 1 : -1).map((org, indx) => {
                                                if (org.region === 'Storkøbenhavn') {
                                                    return org.bios.sort((a, b) => a.city > b.city ? 1 : -1).map((bio) => {
                                                        return <div key={indx} style={{ fontFamily: "PP Neue Montreal", letterSpacing: '0.51px', }} >
                                                            <a href={`https://${bio.URL}`} target="_blank" style={{ height: '10px', fontSize: '17px', color: 'white' }}>{bio.city}, {bio.name}</a>


                                                        </div>
                                                    })
                                                }

                                            })}
                                        </div>
                                })}
                            </div>


       

        <div style={{ color: 'lightgrey', fontSize: '14px' }}>
                        {duplicateElements.sort((a, b) => a > b ? -1 : 1).map((i, index) => {
                            if (i === 'Lolland Falster '  )
                                return <div key={index} style={{ marginBottom: '30px' }}>
                                    <p className='region_name' >{i}</p>
                                    {orgs.sort((a, b) => a.name > b.name ? 1 : -1).map((org, indx) => {
                                        if (org.region === 'Lolland Falster') {
                                            return org.bios.sort((a, b) => a.city > b.city ? 1 : -1).map((bio) => {
                                                return <div key={indx} style={{ fontFamily: "PP Neue Montreal", letterSpacing: '0.51px' }} >
                                                    <a href={`https://${bio.URL}`} target="_blank" style={{ height: '10px', fontSize: '17px', color: 'white' }}>{bio.city}, {bio.name}</a>


                                                </div>
                                            })
                                        }

                                    })}
                                </div>
                            else if (i === 'Samsø')
                                return <div key={index} style={{ marginBottom: '30px' }}>
                                    <p className='region_name' >{i}</p>
                                    {orgs.sort((a, b) => a.name > b.name ? 1 : -1).map((org, indx) => {
                                        if (org.region === 'Samsø') {
                                            return org.bios.sort((a, b) => a.city > b.city ? 1 : -1).map((bio) => {
                                                return <div key={indx} style={{ fontFamily: "PP Neue Montreal", letterSpacing: '0.51px' }} >
                                                    <a href={`https://${bio.URL}`} target="_blank" style={{ height: '10px', fontSize: '17px', color: 'white' }}>{bio.city}, {bio.name}</a>


                                                </div>
                                            })
                                        }

                                    })}
                                </div>
                            else if ( i === 'Sjælland')
                                return <div key={index} style={{ marginBottom: '30px' }}>
                                    <p className='region_name' >{i}</p>
                                    {orgs.sort((a, b) => a.name > b.name ? 1 : -1).map((org, indx) => {
                                        if (org.region === 'Sjælland') {
                                            return org.bios.sort((a, b) => a.city > b.city ? 1 : -1).map((bio) => {
                                            return <div key={indx} style={{ fontFamily: "PP Neue Montreal", letterSpacing: '0.51px' }} >
                                                <a href={`https://${bio.URL}`} target="_blank" style={{ height: '10px', fontSize: '17px', color: 'white' }}>{bio.city}, { bio.name}</a>


                                                </div>
                                            })
                                        }

                                    })}
                                </div>

                        })}
                    </div>
                            <div style={{ color: 'lightgrey', fontSize: '14px' }}>
                                {duplicateElements.sort((a, b) => a > b ? 1 : -1).map((i, index) => {
                                    if (i === 'Jylland')
                                        return <div key={index} style={{ marginBottom: '20px' }}>
                                            <p className='region_name'>{i}</p>
                                            {orgs.sort((a, b) => a.name > b.name ? 1 : -1).map((org, indx) => {
                                                if (org.region === 'Jylland') {
                                                    return org.bios.sort((a, b) => a.city > b.city ? 1 : -1).map((bio) => {
                                                        return <div key={indx} style={{ fontFamily: "PP Neue Montreal", letterSpacing: '0.51px' }}>
                                                            <a href={`https://${bio.URL}`} target="_blank" style={{ height: '10px', fontSize: '17px', color: 'white' }}>{bio.city}, {bio.name}</a>

                                                        </div>
                                                    })
                                                }

                                            })}
                                        </div>
                                })}
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column' }}>


                                {duplicateElements.sort((a, b) => a > b ? -1 : 1).map((i, index) => {
                                    if (i === 'Bornholm' || i === 'Færøerne' || i === 'Grønland' || i === 'Andet')
                                        return <div key={index} style={{ marginBottom: '20px' }}>
                                            <p className='region_name'>{i}</p>
                                            {allOrganizers.map((org, indx) => {
                                                if (org.region === i) {
                                                    return <div key={indx} style={{ fontFamily: "PP Neue Montreal", letterSpacing: '0.51px' }}>
                                                        <a href={`https://${org.URL}`} target="_blank" style={{ height: '10px', fontSize: '17px', color: 'white', }}>{org.city}, {org.name}</a>


                                                    </div>
                                                }

                                            })}
                                        </div>

                                    else if (i === 'Fyn')
                                        return <div key={index} style={{ marginBottom: '20px' }}>
                                            <p className='region_name'>{i}</p>
                                            {orgs.map((org, indx) => {
                                                if (org.region === 'Fyn') {
                                                    return org.bios.sort((a, b) => a.city > b.city ? 1 : -1).map((bio) => {
                                                        return <div key={indx} style={{ fontFamily: "PP Neue Montreal", letterSpacing: '0.51px' }}>
                                                            <a href={`https://${bio.URL}`} target="_blank" style={{ height: '10px', fontSize: '17px', color: 'white', }}>{bio.city}, {bio.name}
                                                            </a>



                                                        </div>
                                                    })
                                                }

                                            })}
                                        </div>
                                }

                                )}



                            </div>

                           


                </section>
            </div>
               

                : <div className='spinner'></div>
            }
        </>
        )
}